import { topicsData } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading text-center">
            热门话题
          </h2>
          <p className="mt-2 text-sm text-foreground-500 text-center">
            大家都在讨论的影视热点
          </p>
          <div className="mt-8 flex flex-wrap justify-center gap-3">
            {topicsData.map((topic) => (
              <span
                key={topic.id}
                className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium cursor-pointer transition-transform hover:scale-105 whitespace-nowrap ${topic.color}`}
              >
                {topic.name}
                <span className="text-xs opacity-70">{topic.count}</span>
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}